<template>
    <section class="small-left">
        <div class="spacing center gray">

            <lottie :name="'chapter-1/diagram-6-convergence'" :width="500" :height="604" />

        </div>
        <div class="spacing space-between">

            <div>

                <h2>The convergence of voice services</h2>
                <h3>Meet every need with one IMS core.</h3>

                <p>Vo5G and VoLTE are simply different ways to access the same IMS-based voice services. 5G must be fully integrated with existing legacy technologies.</p>

            </div>

            <infobutton>
                With a converged cloud-native IMS solution, you can offer voice services for enterprises and fixed broadband customers, even circuit-switched mobile voice customers.
            </infobutton>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>